// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ClaimKeyValuePairLongString {
    static getAttributeTypeMap() {
        return ClaimKeyValuePairLongString.attributeTypeMap;
    }
}
ClaimKeyValuePairLongString.discriminator = undefined;
ClaimKeyValuePairLongString.attributeTypeMap = [
    {
        "name": "key",
        "baseName": "key",
        "type": "number"
    },
    {
        "name": "value",
        "baseName": "value",
        "type": "string"
    }
];
//# sourceMappingURL=claimKeyValuePairLongString.js.map